import Cookies from 'js-cookie'
import SvrApi from "@/svrapi";
import EnvBase from "@/env";

var PT = EnvBase.PT;

const app = {
    state: {
        sidebar: {
            opened: !+Cookies.get('sidebarStatus')
        },
        visitedViews: [],
        navbarData: {
            name: "mike",
            age: 24
        },
        isOrder:false,
        hotelOrFootbathData:'',//酒店足浴信息
        waitOrder: {},          //等待配送信息
        examineRemind: 0,       //审核消息
        whiteListType: true    //审核 白名单状态
    },
    mutations: {
        // 审核 通知
        SET_EXAMINE_REMIND:(state,view) => {
            state.examineRemind = view
        },
        //审核 是否白名单
        SET_WHITE_LIST_TYPE:(state,view) => {
            state.whiteListType = view
        },
        SET_HOTEL_OR_FOOTBATH:(state,view)=>{
            state.hotelOrFootbathData = view
        },
        SET_WAIT_ORDER: (state, view) => {
            state.waitOrder = {
                total:view.total
            }
        },




        TOGGLE_SIDEBAR: state => {
            if (state.sidebar.opened) {
                Cookies.set('sidebarStatus', 1)
            } else {
                Cookies.set('sidebarStatus', 0)
            }
            state.sidebar.opened = !state.sidebar.opened
        },
        ADD_VISITED_VIEWS: (state, view) => {
            if (state.visitedViews.some(v => v.path === view.path)) return
            state.visitedViews.push({ name: view.name, path: view.path })
        },
        DEL_VISITED_VIEWS: (state, view) => {
            let index
            for (const [i, v] of state.visitedViews.entries()) {
                if (v.path === view.path) {
                    index = i
                    break
                }
            }
            state.visitedViews.splice(index, 1)
        },
        GET_NAVBAR_DATA: (state, view) => {
            state.navbarData = view
        },
        GET_ISORDER_DATA: (state, view) => {
            state.isOrder = view
        }
    },
    actions: {
        //审核消息 提醒
        getExamineRemind({ commit }){
            const parame = {
                store_sn: JSON.parse(localStorage.getItem('user_data')).agent_id,
                search_begin_time: '',
                search_end_time: '',
                audit_status: 3,
                keyword: '',
                page: 1,
                page_size: 15
              }
            PT.apiClient.query("/bz-mix/interface/audit/list", parame, function (rsp) {
                console.log('审核消息',rsp)
                const num = rsp.data.total
                
                commit('SET_EXAMINE_REMIND', num)
            });
        },
        //审核白名单状态
        getWhiteListType({ commit }){
            const user_type = JSON.parse(localStorage.getItem('identity')).user_type
            console.log('user_type',user_type)
            if( user_type === 'official_staff' ){
                console.log('审核白名单oss权限')
                return commit('SET_WHITE_LIST_TYPE', true)
            }
            const parame = {
                guid: JSON.parse(localStorage.getItem('identity')).guid
            }
            PT.apiClient.query("/bz-oss/interface/audit/whitelist/check", parame, function (rsp) {
                console.log('审核白名单',rsp)
                const type = rsp.data[0]
                commit('SET_WHITE_LIST_TYPE', type)
            });
        },
        ToggleSideBar({ commit }) {
            commit('TOGGLE_SIDEBAR')
        },
        addVisitedViews({ commit }, view) {
            commit('ADD_VISITED_VIEWS', view)
        },
        delVisitedViews({ commit, state }, view) {
            return new Promise((resolve) => {
                commit('DEL_VISITED_VIEWS', view)
                resolve([...state.visitedViews])
            })
        },
        getNavbarData({ commit }, view) {
            commit('GET_NAVBAR_DATA', view)
        }
    }
}

export default app


// WEBPACK FOOTER //
// ./src/store/modules/app.js